<template>
  <div class="mt-12 ">
      <h5 class="ml-12">Add Packs</h5>
  
    <v-card max-width="90%" class="mx-auto">
      <v-card-title>
        Base Packs
        <div class="flex-grow-1"></div>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table
        :single-select="singleSelect"
        show-select
        :headers="headers"
        :items="detailed"
        :search="search"
      ></v-data-table>

      <div class="form-inline mr-4">
        <div class="flex-grow-1"></div>
        <Button color="primary" class="mb-8" label="Checkout" />
        
      </div>
    </v-card>
    <v-card max-width="90%" class="mt-12 mx-auto">
      <v-card-title>
        Indigital Packs
        <div class="flex-grow-1"></div>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table
        :single-select="singleSelect"
        show-select
        :headers="headers"
        :items="detailed"
        :search="search"
      ></v-data-table>

      <div class="form-inline mr-4">
        <div class="flex-grow-1"></div>
        <Button color="primary" class="mb-8" label=" Checkout" />
      </div>
    </v-card>
      <v-card max-width="90%" class="mt-12 mx-auto">
      <v-card-title>
        Broadcaster Packs
        <div class="flex-grow-1"></div>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table
        :single-select="singleSelect"
        show-select
        :headers="headers"
        :items="detailed"
        :search="search"
      ></v-data-table>

      <div class="form-inline mr-4">
        <div class="flex-grow-1"></div>
        <Button color="primary" class="mb-8 " label=" Checkout" />
      </div>
    </v-card>
  
  
  </div>
</template>
<script>
import Button from "@/components/Elements/Button.vue";
export default {
  components: {
    Button
  },
  data() {
    return {
      singleSelect:"",
      search: "",
      headers: [
        {
          text: "Pack Type",
          align: "left",
          sortable: true,
          value: "name"
        },
        { text: "Pack Name", value: "PackName" },
        { text: "Total Channels ", value: "Total_Channels" },
        { text: "Rental", value: "Rental" },
        { text: "Details", value: "Details" }
      ],
      detailed: [
        {
          name: "Base Pack",
          PackName: 159,
          Total_Channels: 6.0,
          Rental: 24,
          Details: "View Detals"
        },
        {
          name: "INdigital Bouquets",
          PackName: 159,
          Total_Channels: 6.0,
          Rental: 24,
          Details: "View Detals"
        },
        {
          name: "BroadCaster Bouquets",
          PackName: 159,
          Total_Channels: 6.0,
          Rental: 24,
          Details: "View Detals"
        }
      ]
    };
  }
};
</script>